import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter, Link } from 'react-router-dom'
import ReactTable from 'react-table'
import { actions } from '../../redux/modules/helpActions'
import 'react-table/react-table.css'
import moment from 'moment'
import AddEditForm from '../../components/help/AddEditForm'
import { message, Tooltip } from 'antd'
import { filterCaseInsensitive } from '../../util'
import PaginationComponent from '../../components/PaginationComponent'

const propTypes = {}

class Help extends Component {
  componentWillMount() {
    this.props.helpRefresh()

    this.setState({
      modalVisible: false,
      currentId: null,
      currentHelp: null,
      filtered: []
    })
  }

  handleToggleAddEditForm = () => {
    if (this.state.modalVisible) {
      this.setState({
        currentId: null,
        currentHelp: null
      })
    }
    this.setState({
      modalVisible: !this.state.modalVisible
    })
  }

  handleAddHelp = values => {
    values.created_date = moment().format('YYYY-MM-DD HH:mm:ss')
    values.updated_date = moment().format('YYYY-MM-DD HH:mm:ss')
    this.props.createHelp({
      content: values,
      userId: this.props.authentication.user.userId
    })

    this.handleToggleAddEditForm()
    message.success('Help item created')
  }

  handleEditHelp = values => {
    values.updated_date = moment().format('YYYY-MM-DD HH:mm:ss')
    values.updated_by_id = this.props.authentication.user.userId
    this.props.editHelp({
      content: values,
      helpId: this.state.currentId
    })

    this.setState({
      currentId: null,
      currentHelp: null
    })

    this.handleToggleAddEditForm()
    message.success('Help item edited')
  }

  handleDeleteHelp = () => {
    this.props.deleteHelp({
      helpId: this.state.currentId
    })

    this.setState({
      currentId: null,
      currentHelp: null
    })

    this.handleToggleAddEditForm()
    message.success('Help item deleted')
  }

  handleRowClick = row => {
    this.props.getHelpAttachments({ helpId: row.id })
    this.setState({
      currentId: row.id,
      currentHelp: row
    })

    this.handleToggleAddEditForm()
  }

  uploadHelpAttachment = param => {
    this.props.uploadHelpAttachment({
      formData: param.formData,
      helpId: this.state.currentId
    })
  }

  updateHelpAttachmentDescription = param => {
    this.props.updateHelpAttachmentDescription(param)
  }

  deleteHelpAttachment = param => {
    this.props.deleteHelpAttachment(param)
  }

  render() {
    const {
      payload,
      helpHelpAttachments,
      loadingHelpAttachments,
      uploadingHelpAttachment,
      deletingHelpAttachment
    } = this.props.helpActions

    if (!payload) {
      return (
        <div>
          <i className="fa fa-refresh fa-spin fa-3x fa-fw" />
          <span className="sr-only">Loading...</span>
        </div>
      )
    } else {
      return (
        <div>
          <AddEditForm
            currentId={this.state.currentId}
            userId={this.props.authentication.user.userId}
            modalVisible={this.state.modalVisible}
            handleToggleAddEditForm={this.handleToggleAddEditForm}
            handleAddHelp={this.handleAddHelp}
            handleEditHelp={this.handleEditHelp}
            handleDeleteHelp={this.handleDeleteHelp}
            currentHelp={this.state.currentHelp}
            // attachments props
            uploadAttachment={this.uploadHelpAttachment}
            updateAttachmentDescription={this.updateHelpAttachmentDescription}
            deleteAttachment={this.deleteHelpAttachment}
            attachmentList={helpHelpAttachments && helpHelpAttachments.data}
            loadingAttachments={loadingHelpAttachments}
            uploadingAttachment={uploadingHelpAttachment}
            deletingAttachment={deletingHelpAttachment}
          />
          <div className="dataHeader">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active">
                  <Link to="/help">Help</Link>
                </li>
              </ol>
            </nav>
            <h2>Help</h2>
          </div>
          <div className="dataPanel">
            <div className="wrapPanel">
              <div className="jobsBar">
                Help
                <div style={{ display: 'flex' }}>
                  <div className="jobsBarAdd" onClick={this.handleToggleAddEditForm}>
                    <i className="fa fa-plus-square" aria-hidden="true" />
                    &nbsp;<div className="addJobLabel">NEW ITEM</div>
                  </div>
                </div>
              </div>
              <ReactTable
                data={payload.data}
                getTrProps={(state, rowInfo, column, instance) => ({
                  onClick: e => this.handleRowClick(rowInfo.original)
                })}
                filterable
                filtered={this.state.filtered}
                onFilteredChange={filtered => {
                  this.setState({ filtered })
                }}
                defaultFilterMethod={filterCaseInsensitive}
                PaginationComponent={PaginationComponent}
                columns={[
                  {
                    columns: [
                      {
                        Header: 'Title',
                        id: 'title',
                        accessor: 'title',
                        Cell: d => {
                          return <Tooltip title={d.original.title}>{d.original.title}</Tooltip>
                        }
                      },
                      {
                        Header: 'Body',
                        id: 'body',
                        accessor: 'body',
                        minWidth: 200,
                        Cell: d => <Tooltip title={d.original.body}>{d.original.body}</Tooltip>
                      }
                    ]
                  }
                ]}
                defaultPageSize={10}
                className="-striped -highlight"
              />
              <br />
              &copy; 2018 G-Tech Elevator Associates LLC
            </div>
          </div>
        </div>
      )
    }
  }
}

const mapStateToProps = ({ helpActions, authentication }, ownProps) => ({
  helpActions,
  authentication
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(actions, dispatch)
})

Help.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Help))



// WEBPACK FOOTER //
// ./src/containers/help/index.js